import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React, { Fragment, useContext, useEffect, useState } from "react";
import ErrorDialog from "../../../components/notifications/errorDialog/ErrorDialog";
import { ProgressDialog } from "../../../components/notifications/progressDialog/progressDialog";
import { AssetLocation, api } from "../../../logic/api";
import { SessionContext } from "../../../utility/useSession";
import { useTranslation } from "react-i18next";

const LocationDeleteDialog: React.FunctionComponent<{
    location: AssetLocation;
    show: boolean;
    onClose: (reload: boolean) => void;
    onErrorClose: () => void;
}> = (props) => {
    const session = useContext(SessionContext);
    const { t } = useTranslation();

    const [location, setLocation] = useState<AssetLocation | null>(null);
    const setLocationDeleted = api.hooks.assetLocation.setDeleted();

    useEffect(() => {
        if (props.show === true) {
            setLocation(props.location);
        }
    }, [props.show]);

    const deleteLocation = async () => {
        if (!location) {
            return;
        }

        setLocationDeleted.send(session.current.context, {
            id: props.location.id
        }, (result) => {
            if (result === true) {
                props.onClose(true);
            }
            setLocation(null);
        });

    }

    return <Dialog open={props.show}>
        <DialogTitle>
            <Fragment>{t("locations.deleteLocation")}</Fragment>
        </DialogTitle>
        <DialogContent>
            <ProgressDialog status={setLocationDeleted.status}></ProgressDialog>
            <ErrorDialog err={setLocationDeleted.err} onClose={() => { props.onErrorClose() }}></ErrorDialog>
            {location && (
                <Fragment>
                    {t("locations.deleteConfirmation", { location: location.name })}
                </Fragment>
            )}

        </DialogContent>
        <DialogActions>
            <Button data-testid="cancel-delete-location-button" onClick={() => {
                props.onClose(false);
            }}>
                {t("general.cancel")}
            </Button>
            <Button data-testid="confirm-delete-location-button" disabled={!location || location.name.length === 0} onClick={() => {
                deleteLocation();
            }}>
                <b>{t("general.delete")}</b>
            </Button>
        </DialogActions>
    </Dialog>
}

export default LocationDeleteDialog
